<template>
    <div class="bg-white rounded shadow">
        <header class="flex items-center border-b py-3 px-4 sm:px-6 md:py-4">
            <h1 class="text-lg font-normal">
                Create Bank Account
            </h1>
        </header>

        <bank-accounts-store @success="onSuccess">
            <base-form
                slot-scope="{
                    sid,
                    is_loading: is_saving,
                    error,
                    store
                }"
                @submit="store(form)"
            >
                <div class="px-4 pt-6 sm:px-6">
                    <validator-alert :sid="sid" />

                    <form-section>
                        <template slot="title">Bank Account</template>
                        <template slot="description">
                            We deposit funds into your default bank account.
                        </template>

                        <grid-layout>
                            <grid-layout-item class="md:w-1/2">
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="account_number"
                                >
                                    <template slot="label">Account Number</template>

                                    <input-text
                                        v-model="form.account_number"
                                        v-mask="['#### ####']"
                                        :sid="sid"
                                        :disabled="is_saving"
                                        type="tel"
                                        name="account_number"
                                        placeholder="0000 0000"
                                    />
                                </form-item>
                            </grid-layout-item>
                            <grid-layout-item class="md:w-1/2">
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="routing_number"
                                >
                                    <template slot="label">Sort Code</template>

                                    <input-text
                                        v-model="form.routing_number"
                                        v-mask="['##-##-##']"
                                        :sid="sid"
                                        :disabled="is_saving"
                                        type="tel"
                                        name="routing_number"
                                        placeholder="00-00-00"
                                    />
                                </form-item>
                            </grid-layout-item>
                            <grid-layout-item>
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="is_default"
                                >
                                    <template slot="label">Default</template>

                                    <label class="flex items-center cursor-pointer">
                                        <input-checkbox
                                            v-model="form.is_default"
                                            :sid="sid"
                                            :disabled="is_saving"
                                            name="is_default"
                                            class="mr-3"
                                        />

                                        <div class="leading-tight">Make this the default</div>
                                    </label>
                                </form-item>
                            </grid-layout-item>
                        </grid-layout>
                    </form-section>
                </div>

                <div class="bg-grey-bg text-right px-4 py-3 sm:px-6">
                    <base-button
                        :is-loading="is_saving"
                        class="btn-blue w-full md:w-auto"
                    >
                        Create Bank Account
                    </base-button>
                </div>

                <error-modal
                    v-if="error && $error.is(error, { exclude: [400, 422] })"
                    :error="error"
                />

                <modal-success :is-open="show_created_modal">
                    <template slot="heading">Bank account created!</template>

                    <p>Your bank account has been created!</p>

                    <template slot="footer">
                        <div class="flex flex-col md:flex-row-reverse">
                            <router-link
                                :to="{ name: $router.fix('dashboard.*.settings.edit') }"
                                class="btn btn-green text-center"
                            >
                                Go to Settings
                            </router-link>
                        </div>
                    </template>
                </modal-success>
            </base-form>
        </bank-accounts-store>
    </div>
</template>

<script>
    import { mask } from 'vue-the-mask'
    import BankAccountsStore from '../../../../components/bank-accounts-store'

    export default {
        directives: { mask },
        components: {
            BankAccountsStore
        },
        data () {
            return {
                show_created_modal: false,
                form: {
                    country: 'gb',
                    currency: 'gbp',
                    account_number: '',
                    routing_number: '',
                    is_default: true
                }
            }
        },
        methods: {
            onSuccess () {
                setTimeout(() => {
                    this.show_created_modal = true
                }, 0)
            }
        }
    }
</script>
